(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["craftdiy-crystal-builder-v1"] && !Shopify.designMode) return;
  try {
    (function(){
      "use strict";
      function initCrystalBuilders(){
      document.querySelectorAll("[data-crystal-builder]").forEach(function(root){
        if(root.dataset.previewReady==="true")return;
        var productId=root.dataset.productId;
        var shell=document.querySelector('[data-crystal-product-shell][data-product-id="'+productId+'"]');
        var form=shell&&shell.querySelector(".ccr__form");
        var scope=root.querySelector(".cdb-composer__controls")||(shell&&shell.querySelector(".cdb-composer__controls"));
        if(!scope)return;
        root.dataset.previewReady="true";
        var choices=[].slice.call(scope.querySelectorAll("[data-cdp-choice]"));
        var original=scope.querySelector("[data-cdp-original]");
        var current=scope.querySelector("[data-cdp-current]");
        var property=scope.querySelector("[data-cdp-property]");
        var kindProperty=scope.querySelector("[data-cdp-kind-property]");
        var previewProperty=scope.querySelector("[data-cdp-preview-property]");
        var add=scope.querySelector("[data-cdb-add]");
        var addLabel=scope.querySelector("[data-cdp-add-label]");
        var state=scope.querySelector("[data-cdb-state]");
        function announce(src,label){
          if(!shell)return;
          shell.dispatchEvent(new CustomEvent("craftdiy:crystal-preview",{bubbles:true,detail:{src:src||"",alt:label||"Original"}}));
        }
        function setOriginal(){
          choices.forEach(function(choice){choice.classList.remove("is-active");choice.setAttribute("aria-pressed","false")});
          original.hidden=true;
          current.textContent="Original";
          property.value="";
          property.disabled=true;
          kindProperty.disabled=true;
          previewProperty.value="";
          previewProperty.disabled=true;
          addLabel.textContent="ADD TO CART";
          state.textContent="Original design selected.";
          announce("","Original");
        }
        function selectChoice(choice){
          choices.forEach(function(item){var active=item===choice;item.classList.toggle("is-active",active);item.setAttribute("aria-pressed",active?"true":"false")});
          var label=choice.dataset.cdpLabel||"Custom option";
          var src=choice.dataset.cdpPreview||"";
          original.hidden=false;
          current.textContent=label;
          property.value=label;
          property.disabled=false;
          kindProperty.disabled=false;
          previewProperty.value=src;
          previewProperty.disabled=false;
          addLabel.textContent="ADD CUSTOM DESIGN";
          state.textContent=label+" selected. Included at no extra charge.";
          announce(src,label);
        }
        choices.forEach(function(choice){
          choice.addEventListener("click",function(){selectChoice(choice)});
          choice.addEventListener("mouseenter",function(){var src=choice.dataset.cdpPreview;if(!src)return;var image=new Image();image.src=src},{once:true,passive:true});
        });
        original.addEventListener("click",setOriginal);
        add.addEventListener("click",function(){
          if(!form)return;
          var nativeAdd=form.querySelector("[data-add]");
          if(nativeAdd&&nativeAdd.disabled){state.textContent="This option is currently unavailable.";return}
          if(typeof form.requestSubmit==="function")form.requestSubmit();else form.submit();
        });
      });
      }
      if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",initCrystalBuilders,{once:true});else initCrystalBuilders();
      document.addEventListener("shopify:section:load",initCrystalBuilders);
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["craftdiy-crystal-desktop-filters"] && !Shopify.designMode) return;
  try {
    (()=>{
 const mq=matchMedia('(min-width:990px)'),originals=new Map();
 function sync(){
  const active=mq.matches&&document.body.classList.contains('is-cap-crystal-world');
  if(!active){originals.forEach((value,el)=>{if(el.isConnected)el.textContent=value});originals.clear();return}
  const form=document.getElementById('FacetFiltersForm');if(!form)return;
  form.querySelectorAll('details').forEach(detail=>{
   const input=detail.querySelector('input'),label=detail.querySelector('summary>div>span');
   if(!input||!label)return;
   const text=input.name==='filter.v.availability'?'Availability':input.name.startsWith('filter.v.price')?'Price':null;
   if(text&&label.textContent!==text){if(!originals.has(label))originals.set(label,label.textContent);label.textContent=text}
  });
 }
 function start(){sync();new MutationObserver(sync).observe(document.body,{attributes:true,attributeFilter:['class']});const root=document.getElementById('main-collection-filters');if(root)new MutationObserver(sync).observe(root,{childList:true,subtree:true});mq.addEventListener('change',sync)}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["craftdiy-d-nav-v1"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__craftdiyDNavV1) return;
    window.__craftdiyDNavV1 = true;

    const normalize = (value) => String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

    const descriptor = (item) => {
      const directLink = item.querySelector(':scope > a');
      const directSummary = item.querySelector(':scope > details > summary');
      const firstLink = directLink || item.querySelector('a[href]');
      const label = directLink || directSummary || firstLink;
      return {
        item,
        title: (label?.textContent || '').replace(/\s+/g, ' ').trim(),
        normalizedTitle: normalize(label?.textContent),
        url: firstLink?.getAttribute('href') || '#',
        current: Boolean(item.querySelector('[aria-current="page"], .menu-drawer__menu-item--active'))
      };
    };

    const matches = (entry, titles, paths = []) => {
      if (!entry) return false;
      if (titles.includes(entry.normalizedTitle)) return true;
      const url = normalize(entry.url);
      return paths.some((path) => url.includes(path));
    };

    const firstMatch = (entries, titles, paths) =>
      entries.find((entry) => matches(entry, titles, paths));

    const makeLink = (entry, className, fallbackTitle) => {
      if (!entry) return null;
      const link = document.createElement('a');
      link.className = className;
      link.href = entry.url;
      link.textContent = entry.title || fallbackTitle;
      if (entry.current) link.setAttribute('aria-current', 'page');
      return link;
    };

    const makeRow = (entry, modifiers = '') => {
      const row = makeLink(entry, `craftdiy-d-row ${modifiers}`.trim(), '');
      if (!row) return null;
      const label = document.createElement('span');
      label.textContent = row.textContent;
      row.replaceChildren(label);
      if (modifiers.includes('craftdiy-d-row--order')) {
        const arrow = document.createElement('span');
        arrow.className = 'craftdiy-d-arrow';
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '\u2192';
        row.appendChild(arrow);
      }
      return row;
    };

    const makeSummary = (title) => {
      const summary = document.createElement('summary');
      summary.className = 'craftdiy-d-summary';
      const label = document.createElement('span');
      label.textContent = title;
      const toggle = document.createElement('span');
      toggle.className = 'craftdiy-d-toggle';
      toggle.setAttribute('aria-hidden', 'true');
      summary.append(label, toggle);
      return summary;
    };

    const bindDisclosure = (details) => {
      const summary = details.querySelector(':scope > .craftdiy-d-summary');
      const reveal = details.querySelector(':scope > .craftdiy-d-reveal');
      if (!summary || !reveal) return;

      let expanded = details.open;
      let animation = null;
      summary.setAttribute('aria-expanded', String(expanded));

      details.craftdiySetExpanded = (shouldOpen) => {
        expanded = shouldOpen;
        if (animation) animation.cancel();
        animation = null;
        details.open = shouldOpen;
        summary.setAttribute('aria-expanded', String(shouldOpen));
        reveal.style.removeProperty('height');
        reveal.style.removeProperty('opacity');
        reveal.style.removeProperty('transform');
        reveal.style.removeProperty('overflow');
      };

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        const shouldOpen = !expanded;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const currentHeight = details.open ? reveal.getBoundingClientRect().height : 0;
        expanded = shouldOpen;
        summary.setAttribute('aria-expanded', String(expanded));

        if (animation) animation.cancel();

        if (reduceMotion) {
          details.open = shouldOpen;
          animation = null;
          return;
        }

        if (shouldOpen) details.open = true;
        const targetHeight = shouldOpen ? reveal.scrollHeight : 0;
        reveal.style.overflow = 'hidden';
        animation = reveal.animate(
          [
            {
              height: `${currentHeight}px`,
              opacity: shouldOpen && currentHeight === 0 ? 0 : 1,
              transform: shouldOpen && currentHeight === 0 ? 'translateY(-0.4rem)' : 'translateY(0)'
            },
            {
              height: `${targetHeight}px`,
              opacity: shouldOpen ? 1 : 0,
              transform: shouldOpen ? 'translateY(0)' : 'translateY(-0.4rem)'
            }
          ],
          {
            duration: shouldOpen ? 260 : 220,
            easing: shouldOpen ? 'cubic-bezier(0.22, 1, 0.36, 1)' : 'cubic-bezier(0.4, 0, 0.2, 1)',
            fill: 'both'
          }
        );

        const activeAnimation = animation;
        activeAnimation.addEventListener('finish', () => {
          if (animation !== activeAnimation) return;
          if (!expanded) details.open = false;
          reveal.style.removeProperty('overflow');
          animation = null;
          activeAnimation.cancel();
        }, { once: true });
      });
    };

    const makeCollection = (entry, world, detail) => {
      if (!entry) return null;
      const link = document.createElement('a');
      link.className = 'craftdiy-d-collection';
      link.dataset.world = world;
      link.href = entry.url;
      const title = document.createElement('strong');
      title.textContent = entry.title;
      const small = document.createElement('small');
      small.textContent = detail;
      link.append(title, small);
      if (entry.current) link.setAttribute('aria-current', 'page');
      return link;
    };

    const mount = (navigation) => {
      if (navigation.dataset.craftdiyDNavMounted === 'true') return;
      const source = navigation.querySelector(':scope > .menu-drawer__menu');
      const drawer = navigation.closest('.menu-drawer');
      if (!source || !drawer) return;

      const updateWorld = () => {
        const path = window.location.pathname.toLowerCase();
        const crystalPath = path.includes('/collections/crystal') || path.includes('/collections/intention-');
        const crystalClass = document.documentElement.classList.contains('craftdiy-drawer-theme-crystal')
          || document.documentElement.classList.contains('fp-nav-crystal')
          || document.documentElement.classList.contains('craftdiy-announcement-dark');
        drawer.dataset.craftdiyWorld = crystalPath || crystalClass ? 'crystal' : 'warm';
      };

      updateWorld();

      const entries = Array.from(source.querySelectorAll('li')).map(descriptor);
      const home = firstMatch(entries, ['home'], ['/']);
      const allProducts = firstMatch(entries, ['all products', 'shop all', 'catalog'], ['/collections/all']);
      const custom = firstMatch(entries, ['custom jewelry', 'custom jewellery'], ['/collections/custom']);
      const crystal = firstMatch(entries, ['crystal collection', 'crystal collections'], ['/collections/crystal']);
      const order = firstMatch(entries, ['your order', 'track order', 'order status'], ['/pages/order', '/pages/track']);
      const about = firstMatch(entries, ['about us', 'about craftdiy'], ['/pages/about']);
      const collabs = firstMatch(entries, ['collabs', 'collaborations'], ['/pages/collab']);
      const connect = firstMatch(entries, ['connect with craftdiy', 'contact us', 'contact'], ['/pages/contact']);
      const news = firstMatch(entries, ['news', 'blog'], ['/blogs/news']);
      const refund = firstMatch(entries, ['refund policy', 'returns', 'returns & exchanges'], ['/policies/refund', '/pages/refund']);

      if (!home || !allProducts || (!custom && !crystal)) return;

      const kicker = document.createElement('div');
      kicker.className = 'craftdiy-d-kicker';
      const menuLabel = document.createElement('span');
      menuLabel.textContent = 'MENU';
      const warmLabel = document.createElement('span');
      warmLabel.className = 'craftdiy-d-kicker__warm';
      warmLabel.textContent = 'JEWELRY MADE PERSONAL';
      const crystalLabel = document.createElement('span');
      crystalLabel.className = 'craftdiy-d-kicker__crystal';
      crystalLabel.textContent = 'CRYSTALS WITH MEANING';
      kicker.append(menuLabel, warmLabel, crystalLabel);

      const nav = document.createElement('div');
      nav.className = 'craftdiy-d-nav';
      const homeRow = makeRow(home);
      if (homeRow) nav.appendChild(homeRow);

      const shop = document.createElement('details');
      shop.className = 'craftdiy-d-details craftdiy-d-details--shop';
      shop.open = true;
      shop.appendChild(makeSummary('Shop'));
      const shopReveal = document.createElement('div');
      shopReveal.className = 'craftdiy-d-reveal';
      const shopPanel = document.createElement('div');
      shopPanel.className = 'craftdiy-d-shop-panel';
      const allLink = document.createElement('a');
      allLink.className = 'craftdiy-d-all';
      allLink.href = allProducts.url;
      const allTitle = document.createElement('strong');
      allTitle.textContent = allProducts.title;
      const allDetail = document.createElement('small');
      allDetail.textContent = 'View the full collection';
      allLink.append(allTitle, allDetail);
      shopPanel.appendChild(allLink);
      const collections = document.createElement('div');
      collections.className = 'craftdiy-d-collections';
      const customLink = makeCollection(custom, 'custom', 'Names, birthstones & gifts');
      const crystalLink = makeCollection(crystal, 'crystal', 'Color, meaning & energy');
      if (customLink) collections.appendChild(customLink);
      if (crystalLink) collections.appendChild(crystalLink);
      shopPanel.appendChild(collections);
      shopReveal.appendChild(shopPanel);
      shop.appendChild(shopReveal);
      bindDisclosure(shop);
      nav.appendChild(shop);

      const drawerDisclosure = drawer.closest('details');
      if (drawerDisclosure) {
        drawerDisclosure.addEventListener('toggle', () => {
          if (!drawerDisclosure.open) return;
          updateWorld();
          shop.craftdiySetExpanded?.(true);
        });
      }

      const worldObserver = new MutationObserver(updateWorld);
      worldObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

      const orderRow = makeRow(order, 'craftdiy-d-row--order');
      if (orderRow) nav.appendChild(orderRow);

      if (about || connect || news || refund) {
        const aboutGroup = document.createElement('details');
        aboutGroup.className = 'craftdiy-d-details craftdiy-d-details--about';
        aboutGroup.appendChild(makeSummary('About Craftdiy'));
        const aboutReveal = document.createElement('div');
        aboutReveal.className = 'craftdiy-d-reveal';
        const aboutPanel = document.createElement('div');
        aboutPanel.className = 'craftdiy-d-about-panel';
        const aboutLink = makeLink(about, '', 'About us');
        const connectLink = makeLink(connect, '', 'Connect with Craftdiy');
        const newsLink = makeLink(news, '', 'News');
        const refundLink = makeLink(refund, '', 'Refund Policy');
        [aboutLink, connectLink, newsLink, refundLink].filter(Boolean).forEach((link) => aboutPanel.appendChild(link));
        aboutReveal.appendChild(aboutPanel);
        aboutGroup.appendChild(aboutReveal);
        bindDisclosure(aboutGroup);
        nav.appendChild(aboutGroup);
      }

      const collabsRow = makeRow(collabs);
      if (collabsRow) nav.appendChild(collabsRow);

      source.classList.add('craftdiy-d-source');
      source.setAttribute('aria-hidden', 'true');
      source.after(kicker, nav);
      drawer.classList.add('craftdiy-d-drawer');
      navigation.dataset.craftdiyDNavMounted = 'true';
    };

    const mountAll = (scope = document) => {
      scope.querySelectorAll('header-drawer .menu-drawer__navigation').forEach(mount);
    };

    const start = () => {
      mountAll();
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', (event) => {
      mountAll(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["craftdiy-desktop-cart"] && !Shopify.designMode) return;
  try {
    (()=>{
 const mq=matchMedia('(min-width:990px)');let pending=false,generation=0;
 function script(src){return new Promise((resolve,reject)=>{const s=document.createElement('script');s.src=src;s.onload=resolve;s.onerror=reject;document.head.append(s)})}
 async function open(trigger){
  if(!mq.matches)return;
  trigger=trigger||document.getElementById('cart-icon-bubble');
  if(pending)return;pending=true;const token=++generation;trigger.setAttribute('aria-busy','true');
  try{
   const config=document.getElementById('craft-desktop-cart-config');
   for(const src of [config.dataset.drawerCss,config.dataset.cartCss])if(![...document.styleSheets].some(s=>s.href===src||s.href===new URL(src,location.href).href)){const l=document.createElement('link');l.rel='stylesheet';l.href=src;document.head.append(l)}
   let drawer=document.querySelector('cart-drawer');
   if(!drawer){
    const parsed=document.getElementById('craft-desktop-cart-template').content;drawer=parsed.querySelector('cart-drawer').cloneNode(true);
    drawer.dataset.desktopOnly='true';
    parsed.querySelectorAll('link[rel="stylesheet"]').forEach(l=>{if(![...document.querySelectorAll('link[rel="stylesheet"]')].some(x=>x.href===l.href))document.head.append(l.cloneNode(true))});
    document.body.append(drawer);
   }
   drawer.classList.add('animate');
   drawer.querySelector('.drawer__inner').getBoundingClientRect();
   await new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));
   if(token!==generation)return;
   drawer.classList.add('active');document.body.classList.add('overflow-hidden');
   if(!customElements.get('cart-items'))await script(config.dataset.cartScript);
   if(!customElements.get('cart-drawer'))await script(config.dataset.drawerScript);
   await customElements.whenDefined('cart-drawer');
   if(mq.matches&&token===generation)await drawer.open(trigger);else if(!mq.matches)drawer.remove();
  }catch(error){if(token===generation)location.assign(routes.cart_url)}finally{pending=false;trigger.removeAttribute('aria-busy')}
 }
 window.CraftdiyDesktopCart={open};
 document.addEventListener('submit',async event=>{
  const form=event.target;
  if(!mq.matches||!form.matches('.ccr__form,#cd-crystal-product-form'))return;
  event.preventDefault();
  if(form.dataset.desktopCartBusy==='true'||!form.reportValidity())return;
  form.dataset.desktopCartBusy='true';
  const button=form.querySelector('[name="add"],button[type="submit"]');
  if(button)button.disabled=true;
  let error=form.querySelector('[data-desktop-cart-error]');
  if(error)error.remove();
  try{
   const response=await fetch(window.routes.cart_add_url+'.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
   const item=await response.json();
   if(!response.ok||item.status)throw new Error(item.description||window.cartStrings.error);
   open();
   const cart=await fetch(window.routes.cart_url+'.js',{headers:{Accept:'application/json'}}).then(r=>r.json());
   document.querySelectorAll('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]').forEach(s=>s.textContent=cart.item_count);
   document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart}}));
  }catch(e){error=document.createElement('p');error.dataset.desktopCartError='true';error.setAttribute('role','alert');error.textContent=e.message||window.cartStrings.error;form.append(error)}
  finally{delete form.dataset.desktopCartBusy;if(button)button.disabled=false}
 });
 document.addEventListener('click',event=>{const d=event.target.closest('cart-drawer[data-desktop-only]');if(!d||!event.target.closest('.drawer__close,#CartDrawer-Overlay'))return;event.preventDefault();event.stopImmediatePropagation();generation++;d.classList.remove('active');document.body.classList.remove('overflow-hidden');if(typeof d.close==='function')d.close()},true);
 document.addEventListener('keydown',event=>{if(event.key==='Escape'){const d=document.querySelector('cart-drawer[data-desktop-only].active');if(d){generation++;d.classList.remove('active');document.body.classList.remove('overflow-hidden');if(typeof d.close==='function')d.close()}}});
 document.addEventListener('click',event=>{const link=event.target.closest('#cart-icon-bubble');if(!link||!mq.matches||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;event.preventDefault();event.stopImmediatePropagation();open(link)},true);
 mq.addEventListener('change',()=>{if(!mq.matches){const d=document.querySelector('cart-drawer[data-desktop-only]');if(d){d.close();d.remove()}}});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["craftdiy-diy-mark"] && !Shopify.designMode) return;
  try {
    function craftdiyMoveHomepageCrystalMarks(root) {
    root.querySelectorAll('.fp-screen--crystal .fp-card').forEach(function (card) {
      var mark = card.querySelector('.fp-card__media > .craftdiy-diy-mark');
      var bottom = card.querySelector('.fp-card__bottom');
      if (!mark || !bottom) return;
      var arrow = bottom.querySelector('a');
      bottom.insertBefore(mark, arrow || null);
    });
  }

  craftdiyMoveHomepageCrystalMarks(document);
  document.addEventListener('DOMContentLoaded', function () {
    craftdiyMoveHomepageCrystalMarks(document);
  });
  document.addEventListener('shopify:section:load', function (event) {
    craftdiyMoveHomepageCrystalMarks(event.target);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["craftdiy-news-polish"] && !Shopify.designMode) return;
  try {
    (() => {
    const mount = () => {
      if (location.pathname.replace(/\/+$/, '') !== '/blogs/news') return;
      const blog = document.querySelector('.main-blog');
      if (!blog || blog.dataset.craftNewsMounted === 'true') return;

      document.body.classList.add('craft-news-ready');
      const originalTitle = blog.querySelector(':scope > .title--primary');
      const hero = document.createElement('header');
      hero.className = 'craft-news-hero';

      const eyebrow = document.createElement('p');
      eyebrow.className = 'craft-news-hero__eyebrow';
      eyebrow.textContent = 'The CraftDIY Journal';

      const title = document.createElement('h1');
      title.className = 'craft-news-hero__title';
      title.textContent = 'News & Stories';

      const copy = document.createElement('p');
      copy.className = 'craft-news-hero__copy';
      copy.textContent = 'Behind the pieces, creative inspiration, and thoughtful stories from the CraftDIY studio.';

      const note = document.createElement('span');
      note.className = 'craft-news-hero__note';
      note.textContent = 'Craft · Style · Community';

      hero.append(eyebrow, title, copy, note);
      if (originalTitle) originalTitle.replaceWith(hero);
      else blog.prepend(hero);

      blog.querySelectorAll('.blog-articles__article').forEach((article, index) => {
        const image = article.querySelector('.article-card__image img');
        const fullTitle = image?.alt?.trim() || '';
        const headingLinks = article.querySelectorAll('.card__heading a');
        if (fullTitle) headingLinks.forEach((link) => { link.textContent = fullTitle; });

        article.querySelectorAll('.article-card__excerpt').forEach((excerpt) => {
          const raw = excerpt.textContent.trim();
          if (fullTitle && raw.startsWith(fullTitle)) excerpt.textContent = raw.slice(fullTitle.length).trim();
        });

        const media = article.querySelector('.article-card__image-wrapper');
        if (media && !media.querySelector('.craft-news-card__tag')) {
          const tag = document.createElement('span');
          tag.className = 'craft-news-card__tag';
          tag.textContent = index === 0 ? 'Community' : 'Craft & Customization';
          media.appendChild(tag);
        }

        const content = article.querySelector('.article-card > .card__content .card__information');
        const heading = article.querySelector('.article-card > .card__content .card__heading a');
        if (content && heading && !content.querySelector('.craft-news-card__read')) {
          const read = document.createElement('a');
          read.className = 'craft-news-card__read';
          read.href = heading.href;
          read.textContent = 'Read the story';
          content.appendChild(read);
        }
      });

      blog.dataset.craftNewsMounted = 'true';
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
    else mount();
    document.addEventListener('shopify:section:load', mount);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["craftdiy-pc-custom-wheel"] && !Shopify.designMode) return;
  try {
    (()=>{
 const mq=matchMedia('(min-width:750px)');
 function mount(section){
  if(section.dataset.pcCraftMounted)return;
  section.dataset.pcCraftMounted='true';
  const cards=[...section.querySelectorAll('.craft-cat')];
  const titles=[...section.querySelectorAll('[data-title]')];
  const originals=titles.map(t=>t.innerHTML);
  const labels=cards.map(c=>c.querySelector('.craft-cat__label').getAttribute('aria-label'));
  const selector=document.createElement('nav');
  selector.className='pc-craft-selector';
  selector.setAttribute('aria-label','Custom jewelry categories');
  const stage=document.createElement('div');stage.className='pc-craft-stage';
  let current=0,animations=[];
  const backgrounds=cards.map(c=>c.querySelector('.craft-cat__bg').getAttribute('src').replace(/&width=480/,'&width=1600'));
  section.style.setProperty('--pc-category-background','url("'+backgrounds[0]+'")');
  cards.forEach((card,i)=>{
   const src=card.querySelector('.craft-cat__bg').getAttribute('src').replace(/&width=480/,'&width=1200');
   const button=document.createElement('button');button.type='button';
   const thumb=document.createElement('img');thumb.src=src;thumb.alt='';
   const label=card.querySelector('.craft-cat__label img').cloneNode(true);label.className='pc-craft-label-image';label.alt=labels[i];button.setAttribute('aria-label',labels[i]);
   button.append(thumb,label);button.setAttribute('aria-pressed',String(i===0));
   button.addEventListener('click',()=>{if(card.dataset.url)window.location.assign(card.dataset.url)});selector.append(button);
   const slide=document.createElement('div');slide.className='pc-craft-slide'+(i===0?' is-current':'');
   slide.setAttribute('aria-hidden',String(i!==0));slide.inert=i!==0;
   const image=document.createElement('img');image.src=card.querySelector('.craft-cat__main img').getAttribute('src').replace(/&width=480/,'&width=1200');image.alt=labels[i];image.loading=i===0?'eager':'lazy';
   const caption=document.createElement('div');caption.className='pc-craft-caption';
   const count=document.createElement('small');count.textContent=String(i+1).padStart(2,'0')+' / 06 — PERSONALIZED FOR YOU';
   const heading=document.createElement('strong');heading.textContent=labels[i];
   const link=document.createElement('a');link.href=card.dataset.url;link.textContent='Explore collection →';
   caption.append(count,heading,link);slide.append(image,caption);stage.append(slide);
   card.addEventListener('click',()=>{if(mq.matches)show(i)});
   titles[i].addEventListener('click',()=>{if(mq.matches)card.click()});
   titles[i].addEventListener('keydown',e=>{if(mq.matches&&(e.key==='Enter'||e.key===' ')){e.preventDefault();card.click()}});
  });
  section.append(selector,stage);
  function syncOpenState(){
   const open=mq.matches&&section.classList.contains('is-open');
   stage.inert=!open;stage.setAttribute('aria-hidden',String(!open));
   [...selector.children].forEach((button,i)=>button.setAttribute('aria-pressed',String(open&&i===current)));
  }
  new MutationObserver(syncOpenState).observe(section,{attributes:true,attributeFilter:['class']});
  syncOpenState();
  function show(index){
   section.style.setProperty('--pc-category-background','url("'+backgrounds[index]+'")');
   const slides=[...stage.children];
   [...selector.children].forEach((b,i)=>b.setAttribute('aria-pressed',String(section.classList.contains('is-open')&&i===index)));
   if(index===current)return;
   animations.forEach(a=>a.cancel());animations=[];
   slides.forEach((s,i)=>{s.classList.toggle('is-current',i===current||i===index);s.setAttribute('aria-hidden',String(i!==index));s.inert=i!==index});
   const old=slides[current],next=slides[index],direction=index>current?1:-1;
   current=index;
   if(matchMedia('(prefers-reduced-motion: reduce)').matches){old.classList.remove('is-current');return}
   const opts={duration:700,easing:'cubic-bezier(.22,1,.36,1)'};
   animations.push(old.animate([{transform:'translateY(0) rotateX(0deg)',opacity:1},{transform:'translateY('+(-direction*100)+'%) rotateX('+(direction*12)+'deg)',opacity:.4}],opts));
   const incoming=next.animate([{transform:'translateY('+(direction*100)+'%) rotateX('+(-direction*12)+'deg)',opacity:.5},{transform:'translateY(0) rotateX(0deg)',opacity:1}],opts);
   animations.push(incoming);
   incoming.onfinish=()=>slides.forEach((s,i)=>s.classList.toggle('is-current',i===current));
  }
  const observer=new MutationObserver(()=>{
   if(!mq.matches)return;
   const i=cards.findIndex(c=>c.classList.contains('is-active'));
   if(i>=0)show(i);
  });
  cards.forEach(c=>observer.observe(c,{attributes:true,attributeFilter:['class']}));
  function responsive(){
   section.classList.toggle('pc-craft-ready',mq.matches);
   if(mq.matches){
    const top=section.getBoundingClientRect().top+window.scrollY;
    section.style.setProperty('--pc-header-height',Math.max(0,top)+'px');
    const header=document.querySelector('header');
    const headerHeight=header?header.getBoundingClientRect().height:0;
    section.style.setProperty('--pc-header-overlap',Math.max(0,headerHeight+28-top)+'px');
   }
   titles.forEach((t,i)=>{
    if(mq.matches){t.textContent=labels[i];t.setAttribute('role','button');t.tabIndex=0}
    else{t.innerHTML=originals[i];t.removeAttribute('role');t.removeAttribute('tabindex')}
   });
   if(!mq.matches&&section.classList.contains('is-open'))section.querySelector('[data-close]').click();
  }
  mq.addEventListener('change',responsive);window.addEventListener('resize',responsive,{passive:true});responsive();
  window.addEventListener('load',responsive,{once:true});
 }
 function start(){document.querySelectorAll('[data-craft-clean]').forEach(mount)}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 document.addEventListener('shopify:section:load',start);
})();
  } catch(e) { console.error(e); }
})();

})();
